import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProfileOutputResolverService } from '../profile-output/profile-output-resolver.service';

const routes: Routes = [
    {
        path: 'output/claim',
        loadComponent: () =>
            import('../claim-outputs/claim-outputs.component').then(
                (m) => m.ClaimOutputsComponent,
            ),
    },
    {
        path: 'cv',
        loadComponent: () =>
            import('../cv/cv-creation.component').then(
                (m) => m.CvCreationComponent,
            ),
    },
    {
        path: '',
        loadComponent: () =>
            import('./profile-standalone.component').then(
                (m) => m.ProfileStandaloneComponent,
            ),
        children: [
            {
                path: '',
                redirectTo: 'overview',
                pathMatch: 'full',
            },
            {
                path: 'overview',
                loadComponent: () =>
                    import(
                        '../profile-overview/profile-overview.component'
                    ).then((m) => m.ProfileOverviewComponent),
            },
            {
                path: 'awards',
                loadComponent: () =>
                    import('../profile-awards/profile-awards.component').then(
                        (m) => m.ProfileAwardsComponent,
                    ),
            },
            {
                path: 'mentions',
                loadComponent: () =>
                    import(
                        '../profile-mentions/profile-mentions.component'
                    ).then((m) => m.ProfileMentionsComponent),
            },
            {
                path: 'projects',
                loadComponent: () =>
                    import(
                        '../profile-projects/profile-projects.component'
                    ).then((m) => m.ProfileProjectsComponent),
                children: [
                    {
                        path: ':id',
                        loadComponent: () =>
                            import(
                                '../profile-projects/profile-projects-group/profile-projects-group.component'
                            ).then((m) => m.ProfileProjectsGroupComponent),
                        resolve: {
                            resourceType: ProfileOutputResolverService,
                        },
                    },
                ],
            },
            {
                path: 'output',
                loadComponent: () =>
                    import('../profile-output/profile-output.component').then(
                        (m) => m.ProfileOutputComponent,
                    ),
                children: [
                    {
                        path: 'claim',
                        loadComponent: () =>
                            import(
                                '../claim-outputs/claim-outputs.component'
                            ).then((m) => m.ClaimOutputsComponent),
                    },
                    {
                        path: ':id',
                        loadComponent: () =>
                            import(
                                '../profile-output-group/profile-output-group.component'
                            ).then((m) => m.ProfileOutputGroupComponent),
                        resolve: {
                            resourceType: ProfileOutputResolverService,
                        },
                    },
                ],
            },
            {
                path: 'activities',
                loadComponent: () =>
                    import(
                        '../profile-activities/profile-activities.component'
                    ).then((m) => m.ProfileActivitiesComponent),
                children: [
                    {
                        path: ':id',
                        loadComponent: () =>
                            import(
                                '../profile-activities/profile-activities-group/profile-activities-group.component'
                            ).then((m) => m.ProfileActivitiesGroupComponent),
                        resolve: {
                            resourceType: ProfileOutputResolverService,
                        },
                    },
                ],
            },
            {
                path: 'activities_2',
                loadComponent: () =>
                    import(
                        '../profile-activities/profile-activities.component'
                    ).then((m) => m.ProfileActivitiesComponent),
                children: [
                    {
                        path: ':id',
                        loadComponent: () =>
                            import(
                                '../profile-activities/profile-activities-group/profile-activities-group.component'
                            ).then((m) => m.ProfileActivitiesGroupComponent),
                        resolve: {
                            resourceType: ProfileOutputResolverService,
                        },
                    },
                ],
            },
            {
                path: 'activities_3',
                loadComponent: () =>
                    import(
                        '../profile-activities/profile-activities.component'
                    ).then((m) => m.ProfileActivitiesComponent),
                children: [
                    {
                        path: ':id',
                        loadComponent: () =>
                            import(
                                '../profile-activities/profile-activities-group/profile-activities-group.component'
                            ).then((m) => m.ProfileActivitiesGroupComponent),
                        resolve: {
                            resourceType: ProfileOutputResolverService,
                        },
                    },
                ],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ProfileStandaloneRoutingModule {}
